import { Location, Router } from '@reach/router';
import React from 'react';
import { connect } from 'react-redux';
import { BASEPATH } from '../../constants';
import { reportAppLoaded } from '../../lib/fedops';
import { IRootState } from '../../redux/rootReducer';
import navigate from '../../routing/navigate';
import NoMatch from '../../routing/NoMatch';
import Route from '../../routing/Route';
import routes, { RoutePath } from '../../routing/routes';
import styles from '../../styles/_exports.scss';
import PageTransition from './PageTransition';

import './App.global.scss';

interface IAppStateProps {
  isWizardSessionStarted: boolean;
}
interface IAppProps extends IAppStateProps {}

class App extends React.Component<IAppProps> {
  componentDidMount() {
    // redirect to onboarding if wizard session not started (for example opened by shared link in the middle of the wizard flow)
    // https://jira.wixpress.com/browse/WVM-1580
    if (
      !this.props.isWizardSessionStarted &&
      !window.location.pathname.endsWith(RoutePath.ONBOARDING)
    ) {
      navigate(RoutePath.ONBOARDING);
    }

    reportAppLoaded();
  }

  render() {
    return (
      <Location>
        {({ location }) => (
          <PageTransition
            timeout={Number(styles.pageTransitionTime.replace('ms', ''))}
            classNames="page-transition"
          >
            <React.Fragment key={location.key}>
              <Router basepath={BASEPATH} location={location}>
                {routes.map((route) => (
                  <Route key={route.path} path={route.path} route={route} />
                ))}
                <NoMatch default redirectTo={RoutePath.ONBOARDING} />
              </Router>
            </React.Fragment>
          </PageTransition>
        )}
      </Location>
    );
  }
}

function mapStateToProps(state: IRootState): IAppStateProps {
  return {
    isWizardSessionStarted: state.wizardSession.isStarted,
  };
}

export default connect(mapStateToProps)(App);
